import {createSelector} from 'reselect';

// Selectors
const getAppComponentDataSelector = state => ({
  emailVerified: state.util.userData.emailVerified,
  isUserLoggedIn: state.util.isUserLoggedIn,
  isUserPrime: state.util.isUserPrime,
  serum: state.util.walletData.serum,
  userData: state.util.userData
});
const getUtilSelector = state => state.util;
const getConfigSelector = state => state.util.configValues;
const getUserDataSelector = state => state.util.userData;
const getUserAvatarUrlSelector = state => state.util.userData.avatarUrl;
const getUserLogInStatusSelector = state => state.util.isUserLoggedIn;
const getUserPrimeStatusSelector = state => state.util.isUserPrime;
const getUserEmailVerifyStatusSelector = state => state.util.userData.emailVerified;
const getUserIdSelector = state => state.util.userData.id;
const getUserDailyBonusClaimedSelector = state => state.util.userData.me.dailyBonusClaimed;
const getPwNotificationSelector = state => state.util.userData.me.pwNotification;
const getWalletDataSelector = state => state.util.walletData;
const getSerumDataSelector = state => state.util.walletData.serum;
const getMoneyDataSelector = state => state.util.walletData.cash;
const getBookmarksUpdatedSelector = state => state.util.isBookmarksUpdated;
const getCommentDataSelector = state => state.comments;
const getTestimonialSelector = state => state.testimonials;

// Re-selectors
export const getAppComponentData = createSelector(getAppComponentDataSelector, appComponentData => appComponentData);
export const getUtilData = createSelector(getUtilSelector, util => util);
export const getConfigData = createSelector(getConfigSelector,configValues => configValues);
export const getUserData = createSelector(getUserDataSelector, userData => userData);
export const getUserAvatarUrl = createSelector(getUserAvatarUrlSelector, userAvatarUrl => userAvatarUrl);
export const getUserLogInStatus = createSelector(getUserLogInStatusSelector, isUserLoggedIn => isUserLoggedIn);
export const getUserEmailVerifyStatus = createSelector(getUserEmailVerifyStatusSelector, emailVerified => emailVerified);
export const getUserIdReselector = createSelector(getUserIdSelector, userId => userId);
export const getUserPrimeStatus = createSelector(getUserPrimeStatusSelector, isUserPrime => isUserPrime);
export const getUserDailyBonusClaimed = createSelector(getUserDailyBonusClaimedSelector, dailyBonusClaimed => dailyBonusClaimed);
export const getWalletData = createSelector(getWalletDataSelector, walletData => walletData);
export const getSerum = createSelector(getSerumDataSelector, serum => serum);
export const getMoney = createSelector(getMoneyDataSelector, money => money);
export const getPwNotification = createSelector(getPwNotificationSelector, pwNotification => pwNotification);
export const getBookmarksUpdated = createSelector(getBookmarksUpdatedSelector, isBookmarksUpdated => isBookmarksUpdated);
export const getCommentDataReselector = createSelector(getCommentDataSelector, comments => comments);
export const getTestimonialReselector = createSelector(getTestimonialSelector, testimonials => testimonials);
